import React, { useContext } from "react";
import {
   Block,
   Icon,
   Layer,
   ThoriumContext,
   useThemeName,
   useTouchStatus
} from "thorium-ui";
import navIcons from "../../../assets/svg/nav-icons.svg";
import { TopNavLink } from "./TopNavLink";

export const TopNav = (props) => {
   const themeName = useThemeName();
   const isTouch = useTouchStatus();
   const toggleTheme = useContext(ThoriumContext).toggleTheme;
   const fillClr = themeName === "dark" ? "#ffffff" : "#292961";
   const sections = ["home", "about", "projects", "contact"];

   const handleClick = (e, anchor) => {
      e.preventDefault();
      document
         .querySelector(`#${anchor}`)
         .scrollIntoView({ behavior: "smooth" });
   };

   return (
      <Layer
         className={`top-nav ${themeName} ${!isTouch && "non-touch-device"}`}
         justify="between"
      >
         <Block
            all={1}
            style={{ paddingLeft: "2rem", paddingRight: 0 }}
            justify="around"
         >
            <div className="topnav-link" title="theme">
               <div
                  className="topnav-icon-container"
                  id="theme"
                  onClick={toggleTheme}
               >
                  <Icon
                     src={`${navIcons}#theme-${themeName}`}
                     width={760}
                     height={40}
                     fill=""
                  />
               </div>
            </div>
         </Block>
         <Block
            xs={10}
            sm={6}
            md={4}
            lg={3}
            xl={3}
            justify="around"
            style={{ paddingRight: "2rem" }}
         >
            {sections.map((section, ind) => (
               <TopNavLink
                  fillClr={fillClr}
                  icon={`${navIcons}#${section}`}
                  isCurrentSection={props.currentSection === section}
                  key={ind}
                  onClick={(e) => handleClick(e, section)}
                  to={section}
               />
            ))}
         </Block>
      </Layer>
   );
};

export default TopNav;
